import TagText from './gameobjects/text/tagtext/TagText.js';
export default TagText;